import React, {useEffect} from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {getConfig, useActions, useSearch} from '@nl/ui';
import {clearCache} from './utils/clearCache';
import {PageLoading} from './components/loading';

function ConfigLoader(props) {
	const [getConfigAction] = useActions([getConfig]);
	const flushCache = useSearch('flushcache');

	const {isRequested: configLoaded, failed: configLoadFailed} = useSelector((state) => state.config,
			shallowEqual);

	useEffect(() => {
		if (flushCache === 'true') {
			clearCache();
		}
		getConfigAction();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (configLoaded || configLoadFailed) {
		return (props.children);
	}

	return (<PageLoading />);
}

export default ConfigLoader;
